module.exports = __webpack_public_path__ + "img/组 4.54b297b0.webp";